import api from "services/api";
import endPoints from "services/endPoints";
import { showToastAction } from "store/slices/commonSlice";
import { setRentSetupSlice } from "store/slices/RentSetupSlices";

const addRentSetupAction = (data, baseRentData, baseRents, maintenanceCostData, maintenanceCosts, heatingData, heatingCosts, centralizedDeductions, administrativeCost, setLoading, dispatch, onRes) => async () => {
    setLoading(true)
    let payload = {
        regulation_name: data?.regulationName,
        federal_state: data?.federalState,
        note: data?.note,
        base_rent_cost_tier: {
            tier: baseRentData?.tier,
            base_rent: baseRents,
        },
        maintenance_rent_cost_tier: {
            tier: maintenanceCostData?.tier,
            maintenance_rent: maintenanceCosts,
        },
        heating_rent_cost_tier: {
            tier: heatingData?.tier,
            heating_rent: heatingCosts,
            heating_deduction: centralizedDeductions
        },
        administrator_cost_tier: {
            tier: administrativeCost?.tier,
            cost: administrativeCost?.administrativeCost
        }
    }

    if (baseRents.length === 0) {
        delete payload.base_rent_cost_tier.base_rent;
    }

    if (maintenanceCosts.length === 0) {
        delete payload.maintenance_rent_cost_tier.maintenance_rent;
    }

    if (heatingCosts.length === 0) {
        delete payload.heating_rent_cost_tier.heating_rent;
    }

    if (centralizedDeductions.length === 0) {
        delete payload.heating_rent_cost_tier.heating_deduction;
    }

    const res = await api(
        "post",
        endPoints?.RENT_SETUPS,
        payload
    );
    if (res?.success) {
        const info = res?.data?.results;
        onRes(info)
        dispatch(showToastAction({
            type: "success",
            detail: res?.message,
        }))
    } else {
        dispatch(showToastAction({
            type: "error",
            detail: res?.message,
        }))
    }
    setLoading(false)
};

const updateRentSetupAction = (id, data, baseRentData, baseRents, maintenanceCostData, maintenanceCosts, heatingData, heatingCosts, centralizedDeductions, administrativeCost, setLoading, dispatch, onRes) => async () => {
    setLoading(true)
    let payload = {
        regulation_name: data?.regulationName,
        federal_state: data?.federalState,
        note: data?.note,
        base_rent_cost_tier: {
            tier: baseRentData?.tier,
            base_rent: baseRents,
            id: baseRentData?.id
        },
        maintenance_rent_cost_tier: {
            tier: maintenanceCostData?.tier,
            maintenance_rent: maintenanceCosts,
            id: maintenanceCostData?.id
        },
        heating_rent_cost_tier: {
            tier: heatingData?.tier,
            heating_rent: heatingCosts,
            heating_deduction: centralizedDeductions,
            id: heatingData?.id
        },
        administrator_cost_tier: {
            tier: administrativeCost?.tier,
            cost: administrativeCost?.administrativeCost,
            id: administrativeCost?.id
        }
    }

    if (baseRents.length === 0) {
        delete payload.base_rent_cost_tier.base_rent;
    }

    if (maintenanceCosts.length === 0) {
        delete payload.maintenance_rent_cost_tier.maintenance_rent;
    }

    if (heatingCosts.length === 0) {
        delete payload.heating_rent_cost_tier.heating_rent;
    }

    if (centralizedDeductions.length === 0) {
        delete payload.heating_rent_cost_tier.heating_deduction;
    }

    const res = await api(
        "put",
        endPoints?.RENT_SETUPS + `${id}/`,
        payload
    );
    if (res?.success) {
        const info = res?.data?.results;
        onRes(info)
        dispatch(setRentSetupSlice(info))
        dispatch(showToastAction({
            type: "success",
            detail: res?.message,
        }))
    } else {
        dispatch(showToastAction({
            type: "error",
            detail: res?.message,
        }))
    }
    setLoading(false)
};

const getRentsetupListAction = (rows, page, search, baseStatus, onRes) => async () => {
    const res = await api(
        "get",
        endPoints?.RENT_SETUPS + `?limit=${rows}&page=${page}&search=${search || ""}&base_status=${baseStatus || "active"}`,
    );

    if (res?.success) {
        const info = res?.data
        onRes({ list: info?.results, count: res?.data?.count || res?.data?.results?.length })
    }
};

const rentSetupActiveInactiveAction = (ids, action, setLoading, setIsOpen, dispatch, onRes) => async () => {
    setLoading(true)
    const res = await api(
        "patch",
        endPoints?.RENT_SETUPS + `${action}/`,
        { ids: ids },
    );

    if (res?.success) {
        const info = res?.data?.results
        dispatch(showToastAction({
            type: "success",
            detail: res?.message,
        }))
        onRes(info)
    } else {
        dispatch(showToastAction({
            type: "error",
            detail: res?.message,
        }))
    }
    setLoading(false);
    setIsOpen(false)
};

const getRentSetupDetailsAction = (id, dispatch, onRes) => async () => {
    const res = await api(
        "get",
        endPoints?.RENT_SETUPS + `/${id}`,
    );

    if (res?.success) {
        onRes && onRes(res?.data?.results)
        dispatch(setRentSetupSlice(res?.data?.results))
    } else {
        dispatch(showToastAction({
            type: "error",
            detail: res?.message,
        }))
    }
};

//base rents
const updateBaseRentsAction = (data, dispatch, onRes) => async () => {
    let payload = {
        number_of_tenant: data?.number_of_tenant,
        abstract_allowed_size: data?.abstract_allowed_size,
        net_rent: data?.net_rent,
        gross_base_rent: data?.gross_base_rent,
    }
    const res = await api(
        "put",
        endPoints?.BASE_RENT_COST + `${data?.id}/`,
        payload
    );
    if (res?.success) {
        const info = res?.data?.results;
        onRes(info)
        dispatch(showToastAction({
            type: "success",
            detail: res?.message,
        }))
    } else {
        dispatch(showToastAction({
            type: "error",
            detail: res?.message,
        }))
    }
}

const deleteBaseRentsAction = (id, setLoading, dispatch, onRes) => async () => {
    setLoading(true)
    const res = await api(
        "delete",
        endPoints?.BASE_RENT_COST + `${id}/`,
    );
    if (res?.success) {
        const info = res?.data?.results;
        onRes && onRes(info)
        dispatch(showToastAction({
            type: "success",
            detail: res?.message,
        }))
    } else {
        dispatch(showToastAction({
            type: "error",
            detail: res?.message,
        }))
    }
    setLoading(false)
}

//maintenance costs
const updateMaintenanceCostAction = (data, dispatch, onRes) => async () => {
    let payload = {
        number_of_tenant: data?.number_of_tenant,
        size: data?.size,
        avg_cost: data?.avg_cost,
        gross_cost: data?.gross_cost,
    }
    const res = await api(
        "put",
        endPoints?.MAINTENANCE_RENT_COST + `${data?.id}/`,
        payload
    );
    if (res?.success) {
        const info = res?.data?.results;
        onRes(info)
        dispatch(showToastAction({
            type: "success",
            detail: res?.message,
        }))
    } else {
        dispatch(showToastAction({
            type: "error",
            detail: res?.message,
        }))
    }
}

const deleteMaintenanceCostAction = (id, setLoading, dispatch, onRes) => async () => {
    setLoading(true)
    const res = await api(
        "delete",
        endPoints?.MAINTENANCE_RENT_COST + `${id}/`,
    );
    if (res?.success) {
        const info = res?.data?.results;
        onRes && onRes(info)
        dispatch(showToastAction({
            type: "success",
            detail: res?.message,
        }))
    } else {
        dispatch(showToastAction({
            type: "error",
            detail: res?.message,
        }))
    }
    setLoading(false)
}

// heating costs
const updateHeatingCostAction = (data, dispatch, onRes) => async () => {
    let payload = {
        size_from: data?.size_from,
        size_to: data?.size_to,
        cost_oil: data?.cost_oil,
        cost_gas: data?.cost_gas,
        cost_electricity: data?.cost_electricity,
    }
    const res = await api(
        "put",
        endPoints?.HEATING_RENT_COST + `${data?.id}/`,
        payload
    );
    if (res?.success) {
        const info = res?.data?.results;
        onRes(info)
        dispatch(showToastAction({
            type: "success",
            detail: res?.message,
        }))
    } else {
        dispatch(showToastAction({
            type: "error",
            detail: res?.message,
        }))
    }
}

const deleteHeatingCostAction = (id, setLoading, dispatch, onRes) => async () => {
    setLoading(true)
    const res = await api(
        "delete",
        endPoints?.HEATING_RENT_COST + `${id}/`,
    );
    if (res?.success) {
        const info = res?.data?.results;
        onRes && onRes(info)
        dispatch(showToastAction({
            type: "success",
            detail: res?.message,
        }))
    } else {
        dispatch(showToastAction({
            type: "error",
            detail: res?.message,
        }))
    }
    setLoading(false)
}

const getHeatingCostDetailsAction = (id, onRes) => async () => {
    const res = await api("get", endPoints?.HEATING_RENT_COST + `${id}/`,);
    if (res?.success) {
        const info = res?.data?.results;
        onRes && onRes(info)
    }
}

// heating deductions
const updateHeatingDedcutionAction = (data, dispatch, onRes) => async () => {
    let payload = {
        number_of_tenant: data?.number_of_tenant,
        centralized_deduction: data?.centralized_deduction,
    }
    const res = await api(
        "put",
        endPoints?.HEATING_DEDUCTION + `${data?.id}/`,
        payload
    );
    if (res?.success) {
        const info = res?.data?.results;
        onRes(info)
        dispatch(showToastAction({
            type: "success",
            detail: res?.message,
        }))
    } else {
        dispatch(showToastAction({
            type: "error",
            detail: res?.message,
        }))
    }
}

const deleteHeatingDedcutionAction = (id, setLoading, dispatch, onRes) => async () => {
    setLoading(true)
    const res = await api(
        "delete",
        endPoints?.HEATING_DEDUCTION + `${id}/`,
    );
    if (res?.success) {
        const info = res?.data?.results;
        onRes && onRes(info)
        dispatch(showToastAction({
            type: "success",
            detail: res?.message,
        }))
    } else {
        dispatch(showToastAction({
            type: "error",
            detail: res?.message,
        }))
    }
    setLoading(false)
}
export {
    addRentSetupAction,
    updateRentSetupAction,
    getRentsetupListAction,
    rentSetupActiveInactiveAction,
    getRentSetupDetailsAction,
    updateBaseRentsAction,
    deleteBaseRentsAction,
    updateMaintenanceCostAction,
    deleteMaintenanceCostAction,
    updateHeatingCostAction,
    deleteHeatingCostAction,
    updateHeatingDedcutionAction,
    deleteHeatingDedcutionAction,
    getHeatingCostDetailsAction
}